var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaffleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      paddingTop: 2,
      opacity: 0.75
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.6,16.6c-.55,0-1.02-.2-1.41-.59s-.59-.86-.59-1.41.2-1.02.59-1.41.86-.59,1.41-.59,1.02.2,1.41.59.59.86.59,1.41-.2,1.02-.59,1.41-.86.59-1.41.59ZM8.6,16.6c-.55,0-1.02-.2-1.41-.59s-.59-.86-.59-1.41.2-1.02.59-1.41.86-.59,1.41-.59,1.02.2,1.41.59.59.86.59,1.41-.2,1.02-.59,1.41-.86.59-1.41.59ZM14.6,16.6c-.55,0-1.02-.2-1.41-.59s-.59-.86-.59-1.41.2-1.02.59-1.41.86-.59,1.41-.59,1.02.2,1.41.59.59.86.59,1.41-.2,1.02-.59,1.41-.86.59-1.41.59ZM2.6,10.6c-.55,0-1.02-.2-1.41-.59s-.59-.86-.59-1.41.2-1.02.59-1.41.86-.59,1.41-.59,1.02.2,1.41.59.59.86.59,1.41-.2,1.02-.59,1.41-.86.59-1.41.59ZM8.6,10.6c-.55,0-1.02-.2-1.41-.59s-.59-.86-.59-1.41.2-1.02.59-1.41.86-.59,1.41-.59,1.02.2,1.41.59.59.86.59,1.41-.2,1.02-.59,1.41-.86.59-1.41.59ZM14.6,10.6c-.55,0-1.02-.2-1.41-.59s-.59-.86-.59-1.41.2-1.02.59-1.41.86-.59,1.41-.59,1.02.2,1.41.59.59.86.59,1.41-.2,1.02-.59,1.41-.86.59-1.41.59ZM2.6,4.6c-.55,0-1.02-.2-1.41-.59s-.59-.86-.59-1.41.2-1.02.59-1.41.86-.59,1.41-.59,1.02.2,1.41.59.59.86.59,1.41-.2,1.02-.59,1.41-.86.59-1.41.59ZM8.6,4.6c-.55,0-1.02-.2-1.41-.59s-.59-.86-.59-1.41.2-1.02.59-1.41.86-.59,1.41-.59,1.02.2,1.41.59.59.86.59,1.41-.2,1.02-.59,1.41-.86.59-1.41.59ZM14.6,4.6c-.55,0-1.02-.2-1.41-.59s-.59-.86-.59-1.41.2-1.02.59-1.41.86-.59,1.41-.59,1.02.2,1.41.59.59.86.59,1.41-.2,1.02-.59,1.41-.86.59-1.41.59Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaffleIcon);
export default __webpack_public_path__ + "static/media/waffle_icon.40528cca93fc221a094f13b8e4f5f17b.svg";
export { ForwardRef as ReactComponent };